import { supabase } from '../lib/supabase';
import { Brand } from '../types';

export const brandService = {
  // 获取所有品牌
  async getBrands() {
    const { data, error } = await supabase
      .from('brands')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data as Brand[];
  },

  // 获取激活状态的品牌
  async getActiveBrands() {
    const { data, error } = await supabase
      .from('brands')
      .select('*')
      .eq('status', 'active')
      .order('brand_name', { ascending: true });

    if (error) throw error;
    return data as Brand[];
  },

  // 根据ID获取单个品牌
  async getBrandById(id: string) {
    const { data, error } = await supabase
      .from('brands')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as Brand;
  },

  // 创建品牌
  async createBrand(brand: Omit<Brand, 'id' | 'created_at' | 'updated_at'>) {
    const { data, error } = await supabase
      .from('brands')
      .insert([brand])
      .select()
      .single();

    if (error) throw error;
    return data as Brand;
  },

  // 更新品牌
  async updateBrand(id: string, brand: Partial<Brand>) {
    const { data, error } = await supabase
      .from('brands')
      .update(brand)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as Brand;
  },

  // 删除品牌
  async deleteBrand(id: string) {
    const { error } = await supabase
      .from('brands')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
